// Recorded by cmd/escrafter-snapshot from escapade-live. Do not edit: re-record.
// The fallback switchEsCrafter renders when Crafter does not answer (EsCrafter.js).

import img_campaignBuilderDM from '../images/campaignBuilderDM.png';
import img_campaignBuilderLM from '../images/campaignBuilderLM.png';
import img_characterSheetDM from '../images/characterSheetDM.png';
import img_characterSheetLM from '../images/characterSheetLM.png';
import img_chatbotDM from '../images/chatbotDM.png';
import img_chatbotLM from '../images/chatbotLM.png';
import img_codexDM from '../images/codexDM.png';
import img_codexLM from '../images/codexLM.png';
import img_flatscreenMapsDM from '../images/flatscreenMapsDM.png';
import img_flatscreenMapsLM from '../images/flatscreenMapsLM.png';
import img_homebrewEngineDM from '../images/homebrewEngineDM.png';
import img_homebrewEngineLM from '../images/homebrewEngineLM.png';
import img_miniHumanFemaleWizard from '../images/miniHumanFemaleWizard.png';
import img_sessionConsoleDM from '../images/sessionConsoleDM.png';
import img_sessionConsoleLM from '../images/sessionConsoleLM.png';
import img_standaloneServerDM from '../images/standaloneServerDM.png';
import img_standaloneServerLM from '../images/standaloneServerLM.png';
import img_unrealPluginDM from '../images/unrealPluginDM.png';
import img_unrealPluginLM from '../images/unrealPluginLM.png';

export const SNAPSHOT_IMAGES = {
    'campaignBuilderDM.png': img_campaignBuilderDM,
    'campaignBuilderLM.png': img_campaignBuilderLM,
    'characterSheetDM.png': img_characterSheetDM,
    'characterSheetLM.png': img_characterSheetLM,
    'chatbotDM.png': img_chatbotDM,
    'chatbotLM.png': img_chatbotLM,
    'codexDM.png': img_codexDM,
    'codexLM.png': img_codexLM,
    'flatscreenMapsDM.png': img_flatscreenMapsDM,
    'flatscreenMapsLM.png': img_flatscreenMapsLM,
    'homebrewEngineDM.png': img_homebrewEngineDM,
    'homebrewEngineLM.png': img_homebrewEngineLM,
    'miniHumanFemaleWizard.png': img_miniHumanFemaleWizard,
    'sessionConsoleDM.png': img_sessionConsoleDM,
    'sessionConsoleLM.png': img_sessionConsoleLM,
    'standaloneServerDM.png': img_standaloneServerDM,
    'standaloneServerLM.png': img_standaloneServerLM,
    'unrealPluginDM.png': img_unrealPluginDM,
    'unrealPluginLM.png': img_unrealPluginLM,
};

export const SNAPSHOT_ITEMS = {
    '/site/components/en/site-footer.xml': () => import( './items/site/components/en/site-footer.xml.js' ),
    '/site/components/en/site-nav.xml': () => import( './items/site/components/en/site-nav.xml.js' ),
    '/site/components/fr/site-footer.xml': () => import( './items/site/components/fr/site-footer.xml.js' ),
    '/site/components/fr/site-nav.xml': () => import( './items/site/components/fr/site-nav.xml.js' ),
    '/site/website/en/home/index.xml': () => import( './items/site/website/en/home/index.xml.js' ),
    '/site/website/en/legal/index.xml': () => import( './items/site/website/en/legal/index.xml.js' ),
    '/site/website/fr/home/index.xml': () => import( './items/site/website/fr/home/index.xml.js' ),
};
